/* src/app/admin-dashboard/site-system/records/records.component.css */
/*# sourceMappingURL=records.component.css.map */
